module.exports = __webpack_public_path__ + "img/zinc.e6486fc5.png";